import { FaBoxOpen, FaBuilding, FaGear, FaLock, FaUser } from "react-icons/fa6";

export const HeaderTabSetting = ({activeTab, setActiveTab}) => {
    const tabs = [
        { id: "subscription", label: "Langganan", icon: FaBoxOpen }, // Tab baru di paling atas
        { id: "profile", label: "Profil", icon: FaUser },
        { id: "company", label: "Perusahaan", icon: FaBuilding },
        { id: "system", label: "Sistem", icon: FaGear },
        { id: "security", label: "Keamanan", icon: FaLock },
      ];

    return (
        <>
            <div className="w-full md:w-64 space-y-2 flex-shrink-0">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${isActive
                                ? "bg-cyan-500/10 text-cyan-400 border border-cyan-500/20"
                                : "text-slate-400 hover:bg-slate-800/60 border border-transparent hover:border-slate-700/50"
                                }`}
                        >
                            <Icon className="text-base" />
                            {tab.label}
                        </button>
                    );
                })}
            </div>
        </>
    )
}